var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02944 26H16.0906C17.214 26 18.12 25.1192 18.12 24.0271V18.4959C18.12 17.4038 17.214 16.523 16.0906 16.523H10.1472C8.154 16.523 6.5232 14.9377 6.5232 13C6.5232 11.0623 8.154 9.47696 10.1472 9.47696H16.0906C17.214 9.47696 18.12 8.59621 18.12 7.50407V1.9729C18.12 0.880759 17.214 0 16.0906 0H2.02944C0.906 0 0 0.880759 0 1.9729V24.0271C0 25.1192 0.906 26 2.02944 26Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6568 7.43367V11.2385H10.1472C9.13249 11.2385 8.33521 12.0136 8.33521 13.0001C8.33521 13.9865 9.13249 14.7616 10.1472 14.7616H20.6568V18.4608C20.6568 19.2711 21.7078 19.6938 22.2876 19.0949L27.7598 13.3876C28.086 13.0353 28.086 12.4716 27.7236 12.1193L22.2514 6.79952C21.6715 6.23584 20.6568 6.62337 20.6568 7.43367Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.30a9a9c5577c7bad9adc45cb3be7b8d8.svg";
export { ForwardRef as ReactComponent };